export class BlindsGroup {
    id: string;
    name: string;
    listOfBlinds: Array<string>;
}
